<script setup lang="ts">
import type { ImageScatterScrollerItem } from '~kui/components/KUI/Core/ImageScatterScroller/KUICoreImageScatterScroller.vue'

import { Button } from '~ds/components/ui/button';
import { motion } from 'motion-v'
import { useI18n } from 'vue-i18n'

import {
  UNIFIED_ROUTE_CAREERS,
} from '~/constants/routes/unified';

const { t } = useI18n()

const sampleItems: ImageScatterScrollerItem[] = [
  { image: '/images/kui/unified/skateboarders.webp' },
  { label: t('unified.landing.makeAPlan.labels.engineering'), image: '/images/kui/unified/planning-construction.webp' },
  { image: '/images/kui/unified/bike-basket.webp' },
  { image: '/images/kui/unified/construction-2.webp' },
  { image: '/images/kui/unified/sport-team.webp' },
  { label: t('unified.landing.makeAPlan.labels.nursing'), image: '/images/kui/unified/nurses.webp' },
  { label: t('unified.landing.makeAPlan.labels.construction'), image: '/images/kui/unified/construction.webp' },
  { image: '/images/kui/unified/beach-car-road.webp' },
  { label: t('unified.landing.makeAPlan.labels.budgeting'), image: '/images/kui/unified/food-eat-hands.webp' },
  { label: t('unified.landing.makeAPlan.labels.travel'), image: '/images/kui/unified/graduates.webp' },
  { image: '/images/kui/unified/sitting-reading.webp' },
]
</script>

<template>
  <div class="my-24">
    <KUICoreImageScatterScroller
      :items="sampleItems"
      :heading="t('unified.landing.makeAPlan.heading')"
      scroller-container-class="-mt-18"
    >
      <template #header>
        <KUIUnifiedBlinkySectionIntro
          :message="t('unified.landing.makeAPlan.blinkyMessage')"
          bubble-position="top-left"
          align="right"
          class="md:mt-14"
        />
      </template>
    </KUICoreImageScatterScroller>
    <div class="mt-10 mb-14 text-center">
      <motion.div
        :initial="{ opacity: 0, y: 50 }"
        :while-in-view="{ opacity: 1, y: 0 }"
        :transition="{ duration: 0.8, delay: 0.6, type: 'spring' }"
        :in-view-options="{ once: true }"
      >
        <Button
          size="lg"
          class="mt-8"
          as-child
        >
          <NuxtLink :to="UNIFIED_ROUTE_CAREERS">
            {{ t('unified.landing.makeAPlan.cta') }}
          </NuxtLink>
        </Button>
      </motion.div>
    </div>
  </div>
</template>
